<clr-datagrid *ngIf="externalAutomationParameters" #grid class="datagrid-compact meter-list" [clrDgLoading]="loading">

  <clr-dg-action-bar>
    <div class="btn-group">
      <button type="button" class="btn btn-sm btn-secondary" (click)="updateExternalAutomationParameter()">
        <clr-icon shape="refresh"></clr-icon> Refresh
      </button>
    </div>
  </clr-dg-action-bar>

  <clr-dg-column [clrDgField]="'externalId1'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalId1</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalId2'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalId2</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalId3'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalId3</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalId4'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalId4</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalId5'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalId5</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalKey1'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalKey1</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalKey2'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalKey2</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalKey3'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalKey3</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalKey4'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalKey4</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'externalKey5'">
    <ng-container *clrDgHideableColumn="{hidden: false}">ExternalKey5</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'timestamp'">
    <ng-container *clrDgHideableColumn="{hidden: false}">Timestamp</ng-container>
  </clr-dg-column>
  <clr-dg-column [clrDgField]="'value'">
    <ng-container *clrDgHideableColumn="{hidden: false}">Value</ng-container>
  </clr-dg-column>

  <clr-dg-row *clrDgItems="let item of externalAutomationParameters ; index as i" [clrDgItem]="item">
    <clr-dg-cell> {{item.externalId1}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalId2}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalId3}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalId4}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalId5}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalKey1}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalKey2}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalKey3}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalKey4}}</clr-dg-cell>
    <clr-dg-cell> {{item.externalKey5}}</clr-dg-cell>
    <clr-dg-cell> {{item.timestamp.toDate() | xproj_date}}</clr-dg-cell>
    <clr-dg-cell> {{item.value}}</clr-dg-cell>
  </clr-dg-row>

  <clr-dg-footer>
    <clr-dg-pagination #pagination [clrDgPageSize]="10">
      <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100,200]">Parameters per page</clr-dg-page-size>
      {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}} of {{pagination.totalItems}} parameters
    </clr-dg-pagination>
  </clr-dg-footer>
</clr-datagrid>
